import { render, staticRenderFns } from "./SubDistributor.vue?vue&type=template&id=2eb9c142&scoped=true"
import script from "./SubDistributor.vue?vue&type=script&lang=js"
export * from "./SubDistributor.vue?vue&type=script&lang=js"
import style0 from "./SubDistributor.vue?vue&type=style&index=0&id=2eb9c142&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb9c142",
  null
  
)

export default component.exports